import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { upload3001,  Uploadtemplate, dropdownlist, userWisedept } from '../components/ApiProperty';
import { Modal, Form, Button } from 'react-bootstrap';
import {closeButtonStyle, UploadLoadingIcon } from '../components/Propertyfile';
import {  TableHeader, toCamelCaseforTableProps } from "../components/TableProperty"
import { Template_list_columns } from "../components/ApiProperty";
import {  FaPlus,FaEquals, FaArrowUp, FaArrowDown, FaAngleDoubleUp, FaAngleDoubleDown } from "react-icons/fa";
import "../assets/css/DEMautotabledetails.css";
import tableStyles from '../assets/css/sharedTableStyles.module.css';

import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import { useSession } from '../components/SessionContext';


const Preview = () => {
  const location = useLocation();
  const { tableHtml } = location.state || {};
  const navigate = useNavigate();
  const [invalidDeptMessage, setInvalidDeptMessage] = useState('');
  const [tableData, setTableData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [tableName, setTableName] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isTableVisible, setIsTableVisible] = useState(true);
  const [isTableNameVisible, setIsTableNameVisible] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  // State for error message and styling
  const [invalidTableNameMessage, setInvalidTableNameMessage] = useState('');
  // State for managing popups
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control modal visibility
  const [notifyOption, setNotifyOption] = useState('IN'); // State for radio button selection
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'
  const [modalMessage, setModalMessage] = useState('');
  const allowedTypes = ['int', 'varchar', 'date', 'double', 'boolean', 'decimal', 'float', 'char', 'datetime']; // Define allowed types
  // const [loading, setLoading] = useState(false);
  const [isOperatorModalOpen, setIsOperatorModalOpen] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState(null);

  const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(200);
  const [searchTerm, setSearchTerm] = useState('');
  const [isUploadAllowed, setIsUploadAllowed] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [secondModalMessage, setSecondModalMessage] = useState('');
  const [selectedTableName, setSelectedTableName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileSelectionMessage, setFileSelectionMessage] = useState('');
  const [showFileSelectionModal, setShowFileSelectionModal] = useState(false);
  const [activeEditCell, setActiveEditCell] = useState({ rowIndex: null, columnName: null });
  const activeStatus = localStorage.getItem("active_status");
  const templateType = localStorage.getItem("template_type");
  const stage = localStorage.getItem("stage");
  const [departments, setDepartments] = useState("");
  const [selectedDept, setSelectedDept] = useState('');
  console.log("select dept", selectedDept);
  localStorage.setItem('selectedDept', selectedDept); //  Store selected department

  console.log("activeStatus", activeStatus);
  console.log("templateType", templateType);
  console.log("stage", stage);
  let csrfToken = sessionStorage.getItem("tokenizedSession");

  const apiSessionId = sessionStorage.getItem("sessionId");
  console.log("sessionId", apiSessionId);

  const department = sessionStorage.getItem("dept");
  console.log("department", department);


  // Safely retrieve chatMessages from localStorage and parse it
  const designTemplate = JSON.parse(localStorage.getItem('designtemplate')) || [];
  console.log(localStorage);
  console.log("chat messages", localStorage.getItem('designtemplate'), designTemplate);

  let dataModelLocal;
  let tableDatalocal;
  let tableNamelocal;

  if (designTemplate) {

    try {

      const textData = designTemplate;


      dataModelLocal = textData.data_model || '';
      tableDatalocal = textData.table_data || {};
      tableNamelocal = textData.table_name || '';


    } catch (error) {
      console.error('Error parsing latestMessage text:', error);
    }
  }
  useEffect(() => {
    if (tableNamelocal) {
      setTableName(tableNamelocal);
      const isValid = /^[a-z0-9_]+$/.test(tableNamelocal);
      if (!isValid) {
        setInvalidTableNameMessage('Only lowercase letters, numbers, and underscores are allowed. Spaces (or) other Special characters are not allowed');
        setSelectedDept('');
      } else {
        setInvalidTableNameMessage('');
      }
    }
  }, [tableNamelocal]);


  // Define the static response object with the extracted data
  const staticResponse = {
    data_model: dataModelLocal,
    table_data: {
      column_names: tableDatalocal.column_names || [],  // Ensure column_names is defined
    },
    table_name: tableNamelocal,
  };

  // 1. Extract fetchColumns function outside of useEffect
  const fetchColumns = async () => {
    setLoading(true);
    try {
      const config = {
        params: {
          adminId: localStorage.getItem("userid"),
        },
        headers:{
           'x-csrf-token': csrfToken,
        },
        withCredentials: true,
      };

      const response = await axios.post(Template_list_columns, {}, config);

      if (response.data.status === "success") {
        const apiColumns = response.data.columns;
        const { column_names } = staticResponse.table_data;

        const desiredOrder = [
          "col_name",
          "col_type",
          "col_length",
          "col_label",
          "col_key",
          "col_rename",
          "col_active",
          "col_functions",
        ];

        const columnNameMapping = {
          // optionally add mapping
        };

        const defaultReportingRow = {
          col_name: "Reporting_Date",
          col_type: "DATE",
          col_length: "",
          col_label: "REPORTING DATE",
          col_key: "PRIMARY KEY",
          col_rename: "",
          col_active: "",
          col_functions: "",
        };

        const mappedColumnNames = column_names.map((colName) =>
          columnNameMapping[colName] || colName
        );

        const processedData = mappedColumnNames.map((mappedColName) => {
          const matchingColumn = apiColumns.find(
            (col) => col.col_name.toLowerCase() === mappedColName.toLowerCase()
          );

          if (matchingColumn) {
            return matchingColumn;
          } else {
            return desiredOrder.reduce((acc, field) => {
              acc[field] = field === "col_name" ? mappedColName : "";
              return acc;
            }, {});
          }
        });

        const updatedData = processedData.map((row) =>
          row.col_name === "Reporting_Date" ? defaultReportingRow : row
        );

        const isReportingDateIncluded = updatedData.some(
          (row) => row.col_name?.toLowerCase() === "reporting_date"
        );

        if (!isReportingDateIncluded) {
          updatedData.unshift(defaultReportingRow);
        }

        setHeaders(desiredOrder);
        setTableData(updatedData);
      }
    } catch (error) {
      console.error("Error fetching API columns:", error);
    } finally {
      setLoading(false);
    }
  };

  // 2. Use fetchColumns in useEffect
  useEffect(() => {
    fetchColumns();
  }, []);

  // 3. Add fetchColumns inside handleReset
  const handleReset = () => {
    setSelectedTableName(null);
    setInvalidTableNameMessage('');
    setIsTableVisible(true);
    setIsTableNameVisible(true);
    setSelectedRows([]);
    setShowDeletePopup(false);
    setSelectedDept('');
    setInvalidDeptMessage('');
    setTableName('');
    setIsEditMode(false);

    fetchColumns(); // <-- refetch columns on reset
  };



  const handleInputChange = (rowIndex, columnName, value) => {
    const updatedTableData = tableData.map((row, index) => {
      if (index === rowIndex) {
        const updatedRow = { ...row, [columnName]: value };

        // Disable 'col_length' if 'col_type' is 'DATE', 'LONG', 'DOUBLE', or 'DECIMAL' (case insensitive)
        if (columnName === 'col_type') {
          const colType = value ? value.toLowerCase() : "";

          if (['date', 'long', 'datetime'].includes(colType)) {
            updatedRow['col_length'] = "";
          } else if (['double', 'float', 'decimal'].includes(colType)) {
            updatedRow['col_length'] = "18,2"; // Default for decimal types
          } else if (colType === 'int') {
            updatedRow['col_length'] = "8";
          } else if (colType === 'varchar' || colType === 'char') {
            updatedRow['col_length'] = "32";
          } else if (colType === 'boolean') {
            updatedRow['col_length'] = "1";
          }
        }
        if (columnName === 'col_length' && row["col_type"]) {
          const colType = row["col_type"].toLowerCase();

          if (['double', 'float', 'decimal'].includes(colType)) {
            const isValid = /^\d+,\d+$/.test(value);
            if (!isValid && value !== "") {
              console.warn("Invalid col_length format. Expected comma-separated (e.g., 18,2)");
            }
          }
        }

        return updatedRow;
      }
      return row;
    });
    setTableData(updatedTableData);
  };

  const toTitleCase = (str) => {
    return str
      // Replace underscores or hyphens with spaces
      .replace(/[_-]/g, ' ')
      // Add space before capital letters (for camelCase)
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // Capitalize first letter of each word
      .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  };

  // Validation function for data type only
  const isValidDataType = (colType) => {
    return allowedTypes.includes(colType.toLowerCase());
  };

  const handleBlur = (rowIndex, colType, header) => {
    if (header === 'col_type') {
      const updatedTableData = [...tableData];

      // Convert colType to lowercase for case-insensitive comparison
      const colTypeLower = colType ? colType.toLowerCase() : "";

      // Validate if col_type is allowed
      if (!isValidDataType(colTypeLower)) {
        updatedTableData[rowIndex][header] = ''; // Clear the invalid col_type
        updatedTableData[rowIndex]['col_length'] = ''; // Clear col_length if col_type is invalid

        setTableData(updatedTableData);
        setModalMessage(`Allowed datatypes: 'int', 'varchar', 'date', 'double', 'boolean', "datetime", 'decimal'. Invalid data type: <strong>${toTitleCase(colType)}</strong>`);
        setShowModal(true);
      } else {
        // If col_type is 'date', disable and clear col_length
        if (['date', 'long', 'datetime'].includes(colTypeLower)) {
          updatedTableData[rowIndex]['col_length'] = ''; // Ensure col_length is empty
        }

        setTableData(updatedTableData);
      }
    }
  };

  const handleEditClick = () => {
    setIsEditMode(true);
  };


  const handleAddRow = () => {
    setTableData([...tableData, headers.reduce((acc, header) => ({ ...acc, [header]: '' }), {})]);
  };


  const handleDeleteRow = () => {
    const newTableData = tableData.filter((_, index) => !selectedRows.includes(index));
    setTableData(newTableData);
    setSelectedRows([]);
    setShowDeletePopup(false); // Close the delete confirmation popup
  };

  const handleOperatorClick = (rowIndex) => {
    setActiveRowIndex(rowIndex); // Reuse same active row logic
    setIsOperatorModalOpen(true); // Open operator modal
  };

  // Get already selected column in the row
  // Get already selected column in the row
  // const getAvailableOperatorCols = () => {
  //     if (!tableData[activeRowIndex]) return [];
  //     return tableData.map(row => row.col_name).filter(Boolean);
  // };

  const getAvailableOperatorCols = (excludeCols = []) => {
    if (!tableData[activeRowIndex]) return [];

    return tableData
      .map(row => row.col_name)
      .filter(Boolean)
      .filter(col => !selectedColumns.includes(col)) // exclude selected checkboxes
      .filter(col => !excludeCols.includes(col));    // exclude additional columns
  };


  const handleFinalOperatorSelect = (secondCol) => {
    if (!firstCol || !selectedOperator) return;

    let expression = "";

    // Use the template to generate the correct expression format
    if (selectedOperator.template) {
      expression = selectedOperator.template(firstCol, secondCol);
    } else {
      // Fallback for operators without templates
      switch (selectedOperator.params) {
        case 0:
          expression = `${selectedOperator.func}()`;
          break;
        case 1:
          expression = `${selectedOperator.func}(${firstCol})`;
          break;
        case 2:
          expression = `${selectedOperator.func}(${firstCol}, ${secondCol})`;
          break;
        default:
          expression = `${selectedOperator.func}(${firstCol}, ${secondCol})`;
      }
    }

    const updatedData = tableData.map((row, index) => {
      if (index === activeRowIndex) {
        return {
          ...row,
          col_functions: expression
        };
      }
      return row;
    });

    setTableData(updatedData);
    setIsOperatorModalOpen(false);
    setFirstCol(null);
    setSelectedOperator(null);
  };


  const getStepThreeTitle = () => {
    const { params, name } = selectedOperator;

    if (params === 0) return `Apply ${name} function`;
    if (params === 1) return `Apply ${name} to ${firstCol}`;
    if (params === 2) return `Choose second column for ${name}`;
    if (params === "special") {
      // Special cases with hardcoded parameters
      if (name === "DateFromMDY") return `DateFromMDY will use: Month=1, Day=1, Year=${firstCol}`;
      if (name === "DateFromYQ") return `DateFromYQ will use: Year=${firstCol}, Quarter=1`;
    }
    return `Configure ${name} parameters`;
  };

  const generateExpressionPreview = () => {
    const { template, params } = selectedOperator;

    if (template) {
      return template(firstCol, null);
    }

    switch (params) {
      case 0: return `${selectedOperator.func}()`;
      case 1: return `${selectedOperator.func}(${firstCol})`;
      case 2: return `${selectedOperator.func}(${firstCol}, ?)`;
      default: return `${selectedOperator.func}(${firstCol})`;
    }
  };

  const renderParameterSelection = () => {
    const { params, name } = selectedOperator;

    if (params === 0 || params === 1) {
      // For 0 or 1 parameter functions, apply directly
      return (
        <Button variant="btn btn-sm btn-outline-primary"
          onClick={() => handleFinalOperatorSelect(null)}>
          Apply {name} Function
        </Button>
      );
    }

    if (params === 2) {
      // For 2 parameter functions, show second column selection
      return (
        <ul className="list-group mt-2" style={{ height: "150px", overflowY: "auto" }}>
          {getAvailableOperatorCols()
            .filter(col => col !== firstCol && col !== activeColName)
            .map((col, index) => (
              <li key={index} className="list-group-item" style={{ cursor: "pointer" }}
                onClick={() => handleFinalOperatorSelect(col)}>
                {firstCol} {name} {col}
              </li>
            ))}
        </ul>
      );
    }

    if (params === "special") {
      // For special functions with hardcoded parameters
      return (
        <Button variant="btn btn-sm btn-outline-primary"
          onClick={() => handleFinalOperatorSelect(null)}>
          Apply {name} with fixed parameters
        </Button>
      );
    }

    return <p>Parameter selection needed for {name}</p>;
  };

  // const clearSelections = () => {
  //     setFirstCol(null);
  //     setSelectedOperator(null);
  // };

  // const generateExpressionPreview = () => {
  //     const { func, params } = selectedOperator;

  //     switch (params) {
  //         case 0: return `${func}()`;
  //         case 1: return `${func}(${firstCol})`;
  //         default: return `${func}(${firstCol})`;
  //     }
  // };
  const availableOperators = [
    // Arithmetic operators (need 2 columns in specific order)
    { name: "Addition", func: "Addition", params: 2, template: (col1, col2) => `Addition(${col1}, ${col2})` },
    { name: "Subtraction", func: "Subtraction", params: 2, template: (col1, col2) => `Subtraction(${col1}, ${col2})` },
    { name: "Multiplication", func: "Multiplication", params: 2, template: (col1, col2) => `Multiplication(${col1}, ${col2})` },
    { name: "Division", func: "Division", params: 2, template: (col1, col2) => `Division(${col1}, ${col2})` },
    { name: "Modulus", func: "mod", params: 2, template: (col1, col2) => `mod(${col1}, ${col2})` },

    // Date functions (no parameters)
    { name: "Now", func: "now", params: 0, template: () => `now()` },

    // Date extraction functions (single parameter)
    { name: "Year", func: "year", params: 1, template: (col1) => `year(${col1})` },
    { name: "Month", func: "month", params: 1, template: (col1) => `month(${col1})` },
    { name: "Quarter", func: "Quarter", params: 1, template: (col1) => `Quarter(${col1})` },
    { name: "Second", func: "second", params: 1, template: (col1) => `second(${col1})` },
    { name: "DayOfMonth", func: "DayOfMonth", params: 1, template: (col1) => `DayOfMonth(${col1})` },
    { name: "DayOfWeek", func: "DayOfWeek", params: 1, template: (col1) => `DayOfWeek(${col1})` },
    { name: "WeekNumber", func: "WeekNumber", params: 1, template: (col1) => `WeekNumber(${col1})` },
    { name: "DayOfYear", func: "DayOfYear", params: 1, template: (col1) => `DayOfYear(${col1})` },

    // Special date functions with mixed parameters
    {
      name: "DateFromMDY",
      func: "DateFromMDY",
      params: "special",
      template: (col1, col2) => `DateFromMDY(1, 1, ${col1})` // Month=1, Day=1, Year=selected column
    },
    {
      name: "DateFromYQ",
      func: "DateFromYQ",
      params: "special",
      template: (col1, col2) => `DateFromYQ(${col1}, 1)` // Year=selected column, Quarter=1
    }
  ];
  const handleRowSelection = (rowIndex) => {
    const newSelectedRows = [...selectedRows];
    if (newSelectedRows.includes(rowIndex)) {
      newSelectedRows.splice(newSelectedRows.indexOf(rowIndex), 1);
    } else {
      newSelectedRows.push(rowIndex);
    }
    setSelectedRows(newSelectedRows);
  };


  const handleTableNameChange = (e) => {
    const value = e.target.value;
    // Allow only lowercase letters, numbers, and underscores
    const validValue = /^[a-z0-9_]+$/;

    setTableName(value); // Always update the input field

    if (validValue.test(value)) {
      setInvalidTableNameMessage('');
    } else {
      setModalMessage('Only lowercase letters, numbers, and underscores are allowed. Spaces (or) other Special characters are not allowed');
      setSelectedDept(''); // Reset selected department if invalid
    }
  };


  const handleErrorClick = () => {
    // Handle the error without navigating the page
  };

  const handleModalClose = () => {
    if (messageType === 'success') {
      goBack(); // Only navigate if success
    } else {
      setModalMessage(''); // Close modal in case of an error
      handleErrorClick(); // Handle error without navigation
      setMessageType('');
    }
  };



  const handleSubmit = async () => {
    const result = submitTableData();
    if (result) {
      setModalMessage(result.message);
      setMessageType(result.type);
      setShowModal(true);
      if (result.type === "error") return;
    }

    if (!tableName) {
      setInvalidTableNameMessage('Please enter the table name.');
      return;
    }

    const isValid = /^[a-z0-9_]+$/.test(tableName);
    if (!isValid) {
      setInvalidTableNameMessage('Only lowercase letters, numbers, and underscores are allowed. Spaces (or) other Special characters are not allowed');
      setSelectedDept('');
      return;
    }

    setInvalidTableNameMessage('');

    if (!selectedDept) {
      setInvalidDeptMessage('Please select a department.');
      return;
    } else {
      setInvalidDeptMessage('');
    }

    setIsUploadAllowed(true);
    handleUpload(true);
  };


  const handleUpload = async (allowUpload) => {
    // Determine if upload is allowed: use the explicit parameter if provided, otherwise fall back to state
    const uploadAllowed = allowUpload !== undefined ? allowUpload : isUploadAllowed;

    if (!uploadAllowed) {
      setFileSelectionMessage('File validation failed. Please correct the errors and try again.');
      setShowFileSelectionModal(true);
      return;
    }

    try {
      await proceedWithUpload();
    } catch (error) {
      console.error('Error during upload:', error);
      setFileSelectionMessage('An error occurred during the upload. Please try again.');
      setShowFileSelectionModal(true);
    }
  };

  const proceedWithUpload = async () => {

    setLoading(true);
   
    const txtContent = tableData.map(row =>
      headers.map(header => {
        const value = row[header];

        // If the col_type is 'date' or 'long', and the value is null or 'null', return ''
        if (
          ['date', 'long', 'datetime'].includes((row['col_type'] || '').toLowerCase()) &&
          (value === null || value === 'null' || value === 'NULL')
        ) {
          return '';
        }

        return value == null ? '' : value; // fallback for general null handling
      }).join("|")
    ).join("\n");

    const blob = new Blob([txtContent], { type: 'text/plain' });
    const txtFile = new File([blob], `${tableName}.txt`, { type: 'text/plain' });
    const formData = new FormData();
    formData.append('file', txtFile);
    formData.append('tableName', tableName); // Use tableNamelocal
    formData.append('notifyOption', notifyOption); // Include the selected notification option

    try {
      const uploadResponse = await axios.post(upload3001, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'userId': localStorage.getItem('userid'),
          'x-csrf-token': csrfToken,
        },
        withCredentials: true,
      });

      if (uploadResponse.status === 200) {
        const fileName = txtFile.name;
        const fileNameNoExt = tableName.replace('.txt', '');
        const filePath = "/saswork/nas/";
        await callAdditionalApi(fileNameNoExt, filePath, notifyOption);
      }
    } catch (error) {
      console.error('File upload failed:', error.message);
      setIsUploadAllowed(false);
      setInvalidTableNameMessage('File upload failed. Please try again.');
      setModalMessage(true);
    }
    finally {
      setLoading(false);
    }
  };



  const callAdditionalApi = async (editableTableName, filePath, notifyType) => {
    setLoading(true);
    try {
      let config = {
        headers: {
          "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
        },
        withCredentials: true,
        params: {
          "tableName": tableName,
          "dataModel": dataModelLocal,
          "path": `${filePath}${tableName}.txt`,
          "Notifications": "IN",
          "templateType": "AI",
          "dept": selectedDept
        }
      };

      const response = await axios.post(Uploadtemplate, {}, config);
      if (response.data && response.data.active_status && response.data.template_type && response.data.stage) {
        localStorage.setItem("active_status", response.data.active_status);
        localStorage.setItem("template_type", response.data.template_type);
        localStorage.setItem("stage", response.data.stage);
        console.log("Stored in localStorage:", {
          active_status: response.data.active_status,
          template_type: response.data.template_type,
          stage: response.data.stage,
        });
      } else {
        console.log("active_status or template_type is missing or response.data is null");
      }
      if (response.data.status === 'success') {
        const formattedName = toTitleCase(tableName);
        setModalMessage(`<strong>${formattedName}</strong> Template Created Successfully.`);
        setMessageType('success');
        setShowNotifyModal(false);
        setSecondModalMessage(`Click <strong>'Next'</strong> to assign <strong>${formattedName}</strong> Template to the Checker.`);
        setShowSecondModal(true);

        setShowModal(true);
        setSelectedTableName(tableName);
        localStorage.setItem('selectedTableName', tableName);

      }
      else {
        setModalMessage(response.data.message);
        setMessageType('danger');
        setShowModal(true);
        setIsUploadAllowed(false);
      }
    } catch (error) {
      console.error('Error in additional API call:', error.response ? error.response.data : error.message);
      setIsUploadAllowed(false);
      setMessageType('danger');
    }
    finally {
      setLoading(false);
    }
  };


  const handleSecondModalNext = () => {
    setShowSecondModal(false);
    navigate('/gapsyTempAssign');
  };


  const goBack = () => {
    navigate("/AdminautoDEM");
  };

  const handleInteractive = () => {
    // navigate("/AdminautoDEM");
    navigate("/gapsyAdashboard");
  };

  const handleDashboard = () => {
    navigate('/gapsyAdashboard');
  };


  const validateTableData = () => {
    const allowedTypes = ["int", "varchar", "date", "double", "boolean", "decimal", "float", "char", "datetime"];

    const invalidColTypeRow = tableData.find((row) =>
      row.col_type && !allowedTypes.includes(row.col_type.toLowerCase())
    );

    if (invalidColTypeRow) {
      return { type: "error", message: `Allowed datatypes: 'int', 'varchar', 'date', 'double','boolean','datetime', 'decimal', 'float'. Invalid data type: <strong>${toTitleCase(invalidColTypeRow.col_type)}</strong>` };
    }

    const invalidRow = tableData.find((row) => !row.col_name || !row.col_type);

    const invalidColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["varchar", "int"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length === '' || isNaN(row.col_length))
    );

    const rename = tableData.find((row) =>
      row.col_rename &&
      row.col_name &&
      row.col_rename.trim().toLowerCase() === row.col_name.trim().toLowerCase()
    );

    const duplicateColumn = tableData.reduce((acc, row) => {
      const name = row.col_name?.trim().toLowerCase();
      if (name) {
        acc[name] = (acc[name] || 0) + 1;
      }
      return acc;
    }, {});

    const duplicate = Object.entries(duplicateColumn).find(([_, count]) => count > 1);

    const commaSeparatedNumberRegex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/;

    const invalidCommaSeparatedRow = tableData.find((row) =>
      row.col_type &&
      ["double", "decimal", "float"].includes(row.col_type.toLowerCase()) &&
      row.col_value &&
      !commaSeparatedNumberRegex.test(row.col_value.trim())
    );

    const invalidDoubleColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["double", "float", "decimal"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length.trim() === "" || !/^\d+(\.\d+)?(,\d+(\.\d+)?)+$/.test(row.col_length.trim()))
    );

    const invalidColNameRow = tableData.find((row) => {
      const colName = String(row.col_name || "");
      const isValid = /^[A-Za-z0-9_]+$/.test(colName);
      return !isValid;
    });

    const invalidReportingDateRow = tableData.find((row) => {
      const colName = String(row.col_name || "").trim().toLowerCase();
      const colKey = String(row.col_key || "").trim().toLowerCase();
      return colName === "reporting_date" && colKey !== "primary key";
    });

    const primaryKeys = tableData.filter(
      (row) => String(row.col_key || "").toLowerCase() === "primary key"
    );

    const hasOnlyReportingDateAsPK =
      primaryKeys.length === 1 &&
      String(primaryKeys[0].col_name || "").trim().toLowerCase() === "reporting_date";

    const reportingDateAsPrimaryKey = tableData.find(
      (row) =>
        String(row.col_name || "").trim().toLowerCase() === "reporting_date" &&
        String(row.col_key || "").trim().toLowerCase() === "primary key"
    );

    const floatTypes = ['double', 'decimal', 'float'];
    const floatTypesFormatted = floatTypes.map(toTitleCase).join(', ').replace(/, ([^,]*)$/, ' and $1');


    if (duplicate) {
      return { type: "error", message: `COLUMN_NAME <strong>${toTitleCase(duplicate[0])}</strong> is already available. Please choose a different name.` };
    } else if (invalidRow) {
      return { type: "error", message: "Required field(s) must not be <strong>Blank</strong>" };
    } else if (invalidColLengthRow) {
      return { type: "error", message: "COLUMN_LENGTH is required, and must be a valid Number for the selected COLUMN_TYPE" };
    } else if (rename) {
      return { type: "error", message: "<strong>COLUMN_RENAME/strong> field cannot have the same name as <strong>COLUMN_NAME</strong>. Please provide a different name." };
    } else if (invalidCommaSeparatedRow) {
      return { type: "error", message: `COLUMN_LENGTH must be in precision,scale (eg: 18,2) for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidDoubleColLengthRow) {
      return { type: "error", message: `COLUMN_LENGTH must not be <strong>Blank</strong> for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidColNameRow) {
      return { type: "error", message: `Invalid (or) Incorrect COLUMN_NAME <strong>${toTitleCase(invalidColNameRow.col_name)}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed` };
    } else if (invalidReportingDateRow) {
      return { type: "error", message: `<strong>Reporting Date</strong> must be the Primary Key Column.` };
    } else if (primaryKeys.length === 0) {
      return { type: "error", message: "No </strong>Primary Key</strong> Column found in the Template." };
    } else if (hasOnlyReportingDateAsPK && primaryKeys.length === 1) {
      return { type: "error", message: "Include an additional Primary Key Column, other than <strong>Reporting Date</strong>." };
    } else if (!reportingDateAsPrimaryKey && primaryKeys.length > 0) {
      return { type: "warning", message: "COLUMN_NAME <strong>Reporting Date</strong> is missing. Include if it's Required." };
    }

    return null;
  };

  const submitTableData = () => {
    const allowedTypes = ["int", "varchar", "date", "double", "boolean", "decimal", "float", "char", "datetime"];

    const invalidColTypeRow = tableData.find((row) =>
      row.col_type && !allowedTypes.includes(row.col_type.toLowerCase())
    );

    if (invalidColTypeRow) {
      return { type: "error", message: `Allowed datatypes: 'int', 'varchar', 'date', 'double','boolean','datetime', 'decimal', 'float'. Invalid data type: <strong>${toTitleCase(invalidColTypeRow.col_type)}</strong>` };
    }

    const invalidRow = tableData.find((row) => !row.col_name || !row.col_type);

    const invalidColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["varchar", "int"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length === '' || isNaN(row.col_length))
    );

    const rename = tableData.find((row) =>
      row.col_rename &&
      row.col_name &&
      row.col_rename.trim().toLowerCase() === row.col_name.trim().toLowerCase()
    );

    const duplicateColumn = tableData.reduce((acc, row) => {
      const name = row.col_name?.trim().toLowerCase();
      if (name) {
        acc[name] = (acc[name] || 0) + 1;
      }
      return acc;
    }, {});

    const duplicate = Object.entries(duplicateColumn).find(([_, count]) => count > 1);

    const commaSeparatedNumberRegex = /^\d+(\.\d+)?(,\d+(\.\d+)?)*$/;

    const invalidCommaSeparatedRow = tableData.find((row) =>
      row.col_type &&
      ["double", "decimal", "float"].includes(row.col_type.toLowerCase()) &&
      row.col_value &&
      !commaSeparatedNumberRegex.test(row.col_value.trim())
    );

    const invalidDoubleColLengthRow = tableData.find((row) =>
      row.col_type &&
      ["double", "float", "decimal"].includes(row.col_type.toLowerCase()) &&
      (!row.col_length || row.col_length.trim() === "" || !/^\d+(\.\d+)?(,\d+(\.\d+)?)+$/.test(row.col_length.trim()))
    );

    const invalidColNameRow = tableData.find((row) => {
      const colName = String(row.col_name || "");
      const isValid = /^[A-Za-z0-9_]+$/.test(colName);
      return !isValid;
    });

    const invalidReportingDateRow = tableData.find((row) => {
      const colName = String(row.col_name || "").trim().toLowerCase();
      const colKey = String(row.col_key || "").trim().toLowerCase();
      return colName === "reporting_date" && colKey !== "primary key";
    });

    const primaryKeys = tableData.filter(
      (row) => String(row.col_key || "").toLowerCase() === "primary key"
    );

    const hasOnlyReportingDateAsPK =
      primaryKeys.length === 1 &&
      String(primaryKeys[0].col_name || "").trim().toLowerCase() === "reporting_date";


    const floatTypes = ['double', 'decimal', 'float'];
    const floatTypesFormatted = floatTypes.map(toTitleCase).join(', ').replace(/, ([^,]*)$/, ' and $1');


    if (duplicate) {
      return { type: "error", message: `COLUMN_NAME <strong>${toTitleCase(duplicate[0])}</strong> is already available. Please choose a different name.` };
    } else if (invalidRow) {
      return { type: "error", message: "Required field(s) must not be <strong>Blank</strong>" };
    } else if (invalidColLengthRow) {
      return { type: "error", message: "COLUMN_LENGTH is required, and must be a valid Number for the selected COLUMN_TYPE" };
    } else if (rename) {
      return { type: "error", message: "<strong>COLUMN_RENAME/strong> field cannot have the same name as <strong>COLUMN_NAME</strong>. Please provide a different name." };
    } else if (invalidCommaSeparatedRow) {
      return { type: "error", message: `COLUMN_LENGTH must be in precision,scale (eg: 18,2) for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidDoubleColLengthRow) {
      return { type: "error", message: `COLUMN_LENGTH must not be <strong>Blank</strong> for COLUMN_TYPE Double, Float and Decimal` };
    } else if (invalidColNameRow) {
      return { type: "error", message: `Invalid (or) Incorrect COLUMN_NAME <strong>${toTitleCase(invalidColNameRow.col_name)}</strong>. Letters (A-Z, a-z), Numbers (0-9), and Underscores (_) are only allowed` };
    } else if (invalidReportingDateRow) {
      return { type: "error", message: `<strong>Reporting Date</strong> must be the Primary Key Column.` };
    } else if (primaryKeys.length === 0) {
      return { type: "error", message: "No </strong>Primary Key</strong> Column found in the Template." };
    } else if (hasOnlyReportingDateAsPK && primaryKeys.length === 1) {
      return { type: "error", message: "Include an additional Primary Key Column, other than <strong>Reporting Date</strong>." };
    }

    return null;
  };


  const handleUpdate = () => {
    const result = validateTableData();

    if (result) {
      setModalMessage(result.message);
      setMessageType(result.type);  // ← use the `type` from validateTableData directly
      setShowModal(true);

      if (result.type !== "warning") return; // Block submission only if it's an error
    }

    setIsEditMode(false);
    setSelectedRows([]);
  };

  const filteredTableData = tableData.filter(item =>
    Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalRecords = filteredTableData.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const currentRecords = filteredTableData.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);


  useEffect(() => {
    if (searchTerm && filteredTableData.length === 0) {
      setShowNoRecordsModal(true);
      setSearchTerm('');
      setCurrentPage(1);
    }
  }, [searchTerm, filteredTableData]);

  const handleMoveRowUp = (index) => {
    if (index === 0) return;

    const updatedData = [...tableData];
    [updatedData[index - 1], updatedData[index]] = [updatedData[index], updatedData[index - 1]];
    setTableData(updatedData);

    // Update selectedRows to match new order
    const updatedSelectedRows = [...selectedRows];
    if (selectedRows.includes(index)) {
      updatedSelectedRows.splice(updatedSelectedRows.indexOf(index), 1, index - 1);
    } else if (selectedRows.includes(index - 1)) {
      updatedSelectedRows.splice(updatedSelectedRows.indexOf(index - 1), 1, index);
    }
    setSelectedRows(updatedSelectedRows);
  };


  const handleMoveRowDown = (index) => {
    if (index === tableData.length - 1) return;

    const updatedData = [...tableData];
    [updatedData[index + 1], updatedData[index]] = [updatedData[index], updatedData[index + 1]];
    setTableData(updatedData);

    // Update selectedRows to match new order
    const updatedSelectedRows = [...selectedRows];
    if (selectedRows.includes(index)) {
      // Replace index with index + 1
      updatedSelectedRows.splice(updatedSelectedRows.indexOf(index), 1, index + 1);
    } else if (selectedRows.includes(index + 1)) {
      // Replace index + 1 with index
      updatedSelectedRows.splice(updatedSelectedRows.indexOf(index + 1), 1, index);
    }
    setSelectedRows(updatedSelectedRows);
  };



  const handleMoveRowToTop = (index) => {
    if (index === 0) return;
    const updatedData = [...tableData];
    const [movedRow] = updatedData.splice(index, 1);
    updatedData.unshift(movedRow);
    setTableData(updatedData);

    updateSelectionAfterMove(index, 0);
  };

  const updateSelectionAfterMove = (fromIndex, toIndex) => {
    const updatedSelected = [...selectedRows];
    if (updatedSelected.includes(fromIndex)) {
      updatedSelected.splice(updatedSelected.indexOf(fromIndex), 1, toIndex);
    }
    setSelectedRows(updatedSelected);
  };


  const handleMoveRowToBottom = (index) => {
    if (index === tableData.length - 1) return;
    const updatedData = [...tableData];
    const [movedRow] = updatedData.splice(index, 1);
    updatedData.push(movedRow);
    setTableData(updatedData);

    updateSelectionAfterMove(index, updatedData.length - 1);
  };


  //started code for dropdown of col_function 
  const fetchDropdownData = async () => {
    const adminId = localStorage.getItem('userid');

    const config = {
      headers: {
        "adminId": adminId, 'x-csrf-token': csrfToken,
      },
      withCredentials: true,
    };

    try {
      const response = await axios.post(dropdownlist, {}, config);
      const masterTableInfo = response.data?.master_table_info || []; // Safely extract master_table_info
      const colNames = masterTableInfo.map(item => item.col_name); // Extract col_name values
      setColNames(colNames); // Store in state
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };

  // Call the function when the component mounts
  useEffect(() => {
    fetchDropdownData();
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firstCol, setFirstCol] = useState(null);
  const [colNames, setColNames] = useState([]);
  const [selectedColName, setSelectedColName] = useState("");
  const [selectedColumns, setSelectedColumns] = useState([]); // array of col_name
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [searchText, setSearchText] = useState(""); // To filter options

  // Function to handle dropdown button click for a specific row
  const handleDropdownClick = (rowIndex) => {
    setActiveRowIndex(rowIndex); // Set the active row index
    setIsModalOpen(true); // Open the modal
  };

  const handleOptionSelect = (selectedCol) => {

    const updatedData = tableData.map((row, index) => {
      if (index === activeRowIndex) {
        return {
          ...row,
          col_functions: selectedCol ? `dropdown(${selectedCol})` : "" // Clear if empty
        };
      }
      return row;
    });

    setTableData(updatedData); // Update the table data state
  };


  const handleOkClick = () => {
    if (selectedColName !== null) {
      handleOptionSelect(selectedColName); // This will pass empty string too
      setSearchText("");         // Reset search
      setSelectedColName("");    // Reset selection
      setIsModalOpen(false);     // Close modal
    }
  };

  const handleOkClick1 = () => {
    if (selectedColName !== null) {
      handleOptionSelect(selectedColName); // This will pass empty string too
      setSearchText("");         // Reset search
      setSelectedColName("");    // Reset selection
      setSelectedOperator(null); // Reset selected operator
      setIsOperatorModalOpen(false);     // Close modal
    }
  };

  const clearSelections = () => {
    setFirstCol(null);          // Reset first column
    setSelectedOperator(null);
  };

  const filteredColNames = colNames.filter((colName) =>
    colName.toLowerCase().includes(searchText.toLowerCase())
  ); // Filter based on search input


  useEffect(() => {
    const fetchUserDepartments = async () => {

      try {
        let config = {
          headers: {
            "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
          },
          withCredentials: true,
        };
        // const response = await axios.post('http://172.16.119.156:8081/api/dept/userwise', {}, config);
        const response = await axios.post(userWisedept, {}, config);

        if (response.data?.department && Array.isArray(response.data.department)) {
          setDepartments(response.data.department.map((name, index) => ({
            id: index + 1,
            name
          })));
        } else {
          console.error('Unexpected department data structure:', response.data);
          setDepartments([]);
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartments([]);
      }

    };

    fetchUserDepartments();
  }, []);

  const activeColName = tableData[activeRowIndex]?.col_name;


  return (
    <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
      <Header />
      <Navigation />
      <div className="top-0 px-4 py-2 text-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item">
                  <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <i className="bi bi-house me-2"></i>/
                  </a>
                </li>
                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} style={{ cursor: 'pointer' }} onClick={handleInteractive} aria-current="page">
                  <i className="bi bi-chat-dots me-2"></i>1.3 Interactive Builder (AI) /
                </li>
                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                  <i className="bi bi-journal-plus me-2"></i>Create New
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <main className="flex-grow-1 container-fluid">
        <div className={styles.mainContainer}>
          <div className="container-fluid py-2">
            <div className="row">
              {/* Right Column with Buttons  */}
              <div className="col-lg-9 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">

                    <h6 className={`pb-1 ${styles.borderBottom}`}>Interactive Builder (AI)</h6>

                    <div className="row">
                      <div className="col">
                        <div className="table-on-homepage-only">
                          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                            {isTableVisible && (
                              <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
                                <thead className="sticky-header">
                                  <tr>
                                    {isEditMode && <th style={{ textAlign: 'center', fontSize: '12px' }}></th>}
                                    {headers
                                      .filter(header => header !== 'col_rename' && header !== 'col_active')
                                      .map((header, index) => (
                                        <th key={index} style={{ fontSize: '12px', textAlign: 'center' }}>
                                          {TableHeader.aliasNames[header] || header}
                                        </th>
                                      ))}
                                    <th style={{ fontSize: '12px', textAlign: 'center' }}>ACTIONS</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentRecords.map((row, rowIndex) => (
                                    <tr
                                      key={rowIndex}
                                      style={{
                                        lineHeight: '15px',
                                        backgroundColor: row.col_key.toLowerCase() === 'primary key' && row.col_name.toLowerCase() === 'reporting_date' ? '#f9f9f9' : 'transparent'
                                      }}
                                    >
                                      {isEditMode && (
                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={selectedRows.includes(rowIndex)}
                                            onChange={() => handleRowSelection(rowIndex)}
                                            style={{
                                              backgroundColor: selectedRows.includes(rowIndex) ? '#6c757d' : 'transparent',
                                              borderColor: '#6c757d',
                                              width: '16px',
                                              height: '16px',
                                              borderRadius: '50%',
                                              cursor: 'pointer',
                                            }}
                                          />
                                        </td>
                                      )}

                                      {headers
                                        .filter(header => header !== "col_rename" && header !== "col_active")
                                        .map((header, colIndex) => (
                                          <td
                                            key={colIndex}
                                            style={{
                                              fontSize: '12px',
                                              padding: '8px',
                                              textAlign: 'center',
                                              backgroundColor: colIndex % 2 === 0 ? '#ffffff' : '#f9f9f9',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'
                                            }}

                                            onClick={() => {
                                              if (header === "col_type" || header === "col_key") {
                                                setActiveEditCell({ rowIndex, columnName: header });
                                              }
                                            }}
                                          >
                                            {/* {isEditMode ? ( */}
                                            {isEditMode && selectedRows.includes(rowIndex) ? (
                                              header === "col_functions" ? (
                                                <div className="d-flex align-items-center">
                                                  <input
                                                    type="text"
                                                    value={
                                                      row[header] === null ||
                                                        row[header] === "null" ||
                                                        row[header] === "NULL"
                                                        ? ""
                                                        : row[header] || ""
                                                    }
                                                    onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                    onBlur={() => handleBlur(rowIndex, row["col_type"], header)}
                                                    className="form-control form-control-sm"
                                                    style={{
                                                      minWidth: "100px",
                                                      fontSize: "12px",
                                                    }}
                                                    disabled
                                                  />
                                                  <button
                                                    className="btn btn-sm btn-outline-secondary rounded-circle ms-2"
                                                    onClick={() => handleDropdownClick(rowIndex)}
                                                    style={{
                                                      padding: '2px',
                                                      width: '20px',
                                                      height: '20px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center'
                                                    }}
                                                  >
                                                    <FaPlus size={10} />
                                                  </button>
                                                  <button
                                                    className="btn btn-sm btn-outline-secondary rounded-circle ms-2"
                                                    onClick={() => handleOperatorClick(rowIndex)}
                                                    style={{
                                                      padding: '2px',
                                                      width: '20px',
                                                      height: '20px',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center'
                                                    }}
                                                  >
                                                    <FaEquals size={10} /> {/* use any operator icon e.g., from react-icons */}
                                                  </button>

                                                </div>
                                              ) : header === "col_key" && activeEditCell.rowIndex === rowIndex && activeEditCell.columnName === header ? (
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={row[header] || ""}
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => {
                                                    handleBlur(rowIndex, row["col_type"], header);
                                                    setActiveEditCell({ rowIndex: null, columnName: null });
                                                  }}
                                                  style={{ fontSize: '12px' }}
                                                  autoFocus
                                                >
                                                  <option value="">Select Key</option>
                                                  {["PRIMARY KEY", "NOT NULL", "NULL"].map((keyType) => (
                                                    <option key={keyType} value={keyType}>{keyType}</option>
                                                  ))}
                                                </select>
                                              ) : header === "col_type" && activeEditCell.rowIndex === rowIndex && activeEditCell.columnName === header ? (
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={row[header] || ""}
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => {
                                                    handleBlur(rowIndex, row["col_type"], header);
                                                    setActiveEditCell({ rowIndex: null, columnName: null });
                                                  }}
                                                  style={{ fontSize: '12px' }}
                                                  autoFocus
                                                >
                                                  <option value="">Select Type</option>
                                                  {["INT", "VARCHAR", "DATE", "DOUBLE", "BOOLEAN", "DECIMAL", "FLOAT", "CHAR", "DATETIME"].map((type) => (
                                                    <option key={type} value={type}>{type}</option>
                                                  ))}
                                                </select>
                                              ) : (
                                                <input
                                                  type="text"
                                                  value={
                                                    row[header] === null ||
                                                      row[header] === "null" ||
                                                      row[header] === "NULL"
                                                      ? ""
                                                      : row[header] || ""
                                                  }
                                                  onChange={(e) => handleInputChange(rowIndex, header, e.target.value)}
                                                  onBlur={() => handleBlur(rowIndex, row["col_type"], header)}
                                                  className="form-control form-control-sm"
                                                  style={{
                                                    minWidth: "100px",
                                                    fontSize: "12px",
                                                  }}
                                                  disabled={
                                                    header === "col_length" &&
                                                    row["col_type"] &&
                                                    ["date", "long"].includes(row["col_type"].toLowerCase())
                                                  }
                                                />
                                              )
                                            ) : header === "col_label" ? (
                                              toCamelCaseforTableProps(row[header] || "")
                                            ) : ["col_key", "col_type", "col_name"].includes(header) ? (
                                              (row[header] || "").toLowerCase()
                                            ) : row[header] === null || row[header] === "null" || row[header] === "NULL" ? (
                                              ""
                                            ) : (
                                              row[header]
                                            )}
                                          </td>
                                        ))}

                                      {/* Action Buttons */}
                                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        <div className="d-flex justify-content-center">
                                          <button
                                            onClick={() => handleMoveRowUp(rowIndex)}
                                            disabled={rowIndex === 0}
                                            className="btn btn-sm p-0 me-2"
                                            style={{ color: '#366872', border: 'none' }}
                                            title="Move Up"
                                          >
                                            <FaArrowUp size={12} />
                                          </button>
                                          <button
                                            onClick={() => handleMoveRowDown(rowIndex)}
                                            disabled={rowIndex === currentRecords.length - 1}
                                            className="btn btn-sm p-0 me-2"
                                            style={{ color: '#366872', border: 'none' }}
                                            title="Move Down"
                                          >
                                            <FaArrowDown size={12} />
                                          </button>
                                          <button
                                            onClick={() => handleMoveRowToTop(rowIndex)}
                                            disabled={rowIndex === 0}
                                            className="btn btn-sm p-0 me-2"
                                            style={{ color: '#366872', border: 'none' }}
                                            title="Move to Top"
                                          >
                                            <FaAngleDoubleUp size={12} />
                                          </button>
                                          <button
                                            onClick={() => handleMoveRowToBottom(rowIndex)}
                                            disabled={rowIndex === currentRecords.length - 1}
                                            className="btn btn-sm p-0"
                                            style={{ color: '#366872', border: 'none' }}
                                            title="Move to Bottom"
                                          >
                                            <FaAngleDoubleDown size={12} />
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Left Column with Table */}
              <div className="col-lg-3 col-md-12">
                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                  <div className="card-body">
                    <div className="mb-4">
                      <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Required Info</h6>
                      <div className="d-flex flex-column gap-3">
                        {isTableNameVisible && (

                          <div>
                            <label htmlFor="tableName" className="form-label text-black mb-1">Table Name</label>
                            <input
                              type="text"
                              id="tableName"
                              value={tableName}
                           
                              onChange={handleTableNameChange}
                              className={`form-control form-control-sm ${invalidTableNameMessage ? 'is-invalid' : ''}`}
                              placeholder="Enter table name"
                              disabled={isDownloaded}
                            />

                          </div>
                        )}
                        {invalidTableNameMessage && (
                          <div className="invalid-feedback d-block" style={{ color: 'black', fontSize: '12px' }}>
                            {invalidTableNameMessage}
                          </div>
                        )}
                        {isTableNameVisible && (
                          <div className="mb-3">
                            <label htmlFor="department" className="form-label text-black mb-1">
                              Department
                            </label>
                            <select
                              id="department"
                              className={`form-select form-select-sm ${invalidDeptMessage ? 'is-invalid' : ''}`}
                              value={selectedDept}
                              onChange={(e) => {
                                setSelectedDept(e.target.value);
                                setInvalidDeptMessage(''); // Clear message on valid selection
                              }}
                              disabled={!/^[a-z0-9_]+$/.test(tableName) || !tableName}

                            >
                              <option value="">Select Department</option>
                              {departments.length > 0 ? (
                                [...departments]
                                  .sort((a, b) => a.name.localeCompare(b.name))
                                  .map(dept => (
                                    <option key={dept.id} value={dept.name}>
                                      {dept.name}
                                    </option>
                                  ))
                              ) : (
                                <option disabled>No departments available</option>
                              )}
                            </select>
                            {invalidDeptMessage && (
                              <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                                {invalidDeptMessage}
                              </div>
                            )}
                            {!tableName && !invalidDeptMessage && (
                              <div className="text-muted mt-1" style={{ fontSize: '12px' }}>
                                Enter a valid table name to select department.
                              </div>
                            )}
                          </div>
                        )}
                        {/* Buttons */}
                        {!isEditMode && !isDownloaded && (
                          <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-outline-secondary" onClick={handleEditClick}>Edit</button>
                            <button className="btn btn-sm btn-outline-primary" onClick={handleSubmit} disabled={!tableName || !selectedDept}>Submit</button>
                          </div>
                        )}
                        {isEditMode && (
                          
                          <div className="d-flex flex-wrap gap-3">
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={handleAddRow}
                              title="Add Row"
                            >
                              <i className="bi bi-plus" style={{ fontSize: '24px' }}></i>
                            </button>

                            <div
                              className="d-inline-block"
                              title={selectedRows.length === 0 ? "Select checkbox and delete" : "Delete Row"}
                              data-bs-toggle="tooltip"
                            >
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => setShowDeletePopup(true)}
                                disabled={selectedRows.length === 0}
                                style={{ pointerEvents: selectedRows.length === 0 ? 'none' : 'auto' }}
                              >
                                <i className="bi bi-trash" style={{ fontSize: '24px' }}></i>
                              </button>
                            </div>

                            <button
                              className="btn btn-sm btn-outline-success"
                              onClick={handleUpdate}
                              title="Update"
                            >
                              <i className="bi bi-upload" style={{ fontSize: '24px' }}></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-dark"
                              onClick={handleReset}
                              title="Reset"
                            >
                              <i className="bi bi-x-circle" style={{ fontSize: '24px' }}></i>
                            </button>
                          </div>

                        )}

                      </div>
                    </div>
                  </div>
                </div>

                {loading && (
                  <div className="loading-overlay">
                    <UploadLoadingIcon />
                  </div>
                )}

                <Modal show={showDeletePopup} onHide={() => setShowDeletePopup(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                  <Modal.Header style={{
                    backgroundColor: '#366872',
                    color: 'white',
                    padding: '0.5rem 1rem'
                  }}
                  >
                    <Modal.Title style={{ fontSize: '16px' }}>Delete Confirmation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                    <p>Are you sure you want to Delete the selected row?</p>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: 'none' }}>

                    <Button variant="secondary"
                      onClick={() => setShowDeletePopup(false)}>Cancel</Button>
                    <Button variant="primary"
                      onClick={handleDeleteRow}>Delete</Button>
                  </Modal.Footer>
                </Modal>


                <Modal
                  show={isModalOpen}
                  onHide={() => setIsModalOpen(false)}
                  centered
                  style={{ marginTop: "0vh" }}
                >

                  <Modal.Header
                    style={{
                      backgroundColor: '#366872',
                      color: 'white',
                      padding: '0.5rem 1rem'
                    }}
                  >
                    <Modal.Title style={{ fontSize: '16px' }}>
                      Select a function
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ fontSize: '14px' }}>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control sm"
                        placeholder="Type to search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                      <ul
                        className="list-group mt-2"
                        style={{
                          height: "150px",
                          overflowY: "auto",
                          border: "1px solid #ced4da", // Border for the list container
                          borderRadius: "0.25rem",
                          padding: "0", // Remove padding to avoid extra spacing
                          margin: "0", // Remove margin to avoid extra space around the list
                        }}
                      >
                        <li
                          className={`list-group-item ${selectedColName === "" ? "active" : ""}`}
                          onClick={() => setSelectedColName("")}
                          style={{
                            cursor: "pointer",
                            backgroundColor: selectedColName === "" ? "#e9ecef" : "transparent",
                            color: selectedColName === "" ? "#495057" : "#212529",
                            border: "none",
                            padding: "2px 5px",

                          }}
                        >
                          Clear selection
                        </li>

                        {filteredColNames.length > 0 ? (
                          filteredColNames.map((colName, index) => (
                            <li
                              key={index}
                              className={`list-group-item ${colName === selectedColName ? "active" : ""}`}
                              onClick={() => setSelectedColName(colName)}
                              style={{
                                cursor: "pointer",
                                backgroundColor: selectedColName === colName ? "#e9ecef" : "transparent", // Highlight selected column
                                color: selectedColName === colName ? "#495057" : "#212529", // Change text color for selected column
                                border: "none", // Remove borders between list items
                                padding: "2px 5px", // Minimal padding for list items
                              }}
                            >
                              {colName}
                            </li>
                          ))
                        ) : (
                          <li className="list-group-item text-muted" style={{ border: "none" }}>No matching columns</li>
                        )}
                      </ul>
                    </div>
                  </Modal.Body>
                  <Modal.Footer
                    style={{ borderTop: 'none' }}>
                    <Button variant="btn btn-sm btn-outline-secondary"

                      onClick={() => setIsModalOpen(false)}>
                      Close
                    </Button>
                    <Button

                      variant="btn btn-sm btn-outline-primary" onClick={handleOkClick}>
                      OK
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal show={isOperatorModalOpen} onHide={() => setIsOperatorModalOpen(false)} centered>
                  <Modal.Header style={{ backgroundColor: '#6c757d', color: 'white', padding: '0.5rem 1rem' }}>
                    <Modal.Title style={{ fontSize: '16px' }}>Select Operator</Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ fontSize: '14px' }}>
                    <div className="form-group">
                      {!firstCol && (
                        <>
                          <p><strong>Step 1: Choose first column</strong></p>
                          <ul className="list-group mt-2" style={{ height: "150px", overflowY: "auto" }}>
                            {getAvailableOperatorCols([activeColName]).map((col, index) => (
                              <li key={index} className="list-group-item" style={{ cursor: "pointer" }}
                                onClick={() => setFirstCol(col)}>
                                {col}
                              </li>
                            ))}
                          </ul>
                        </>
                      )}

                      {firstCol && !selectedOperator && (
                        <>
                          <p><strong>Step 2: Choose operator for {firstCol}</strong></p>
                          {availableOperators.map((op, i) => (
                            <Button key={i} size="sm" variant="outline-primary" className="me-2 mb-2"
                              onClick={() => setSelectedOperator(op)}>
                              {op.name}
                            </Button>
                          ))}
                        </>
                      )}

                      {firstCol && selectedOperator && (
                        <>
                          <p><strong>Step 3: {getStepThreeTitle()}</strong></p>
                          <div className="mb-2">
                            <small className="text-muted">
                              Preview: <code>{generateExpressionPreview()}</code>
                            </small>
                          </div>
                          {renderParameterSelection()}
                        </>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: 'none' }}>
                    <Button variant="btn btn-sm btn-outline-secondary" onClick={clearSelections}>
                      Clear
                    </Button>
                    <Button variant="btn btn-sm btn-outline-primary" onClick={handleOkClick1}>
                      OK
                    </Button>
                  </Modal.Footer>
                </Modal>


                <Modal show={modalMessage} backdrop="static"  // <-- This prevents closing on outside click
                  keyboard={false} style={{ marginTop: '12vh' }}>
                  <div
                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                    role="alert"
                    style={{ marginBottom: '0' }}
                  >
                    <div className="d-flex align-items-center">
                      {messageType === 'success' ? (
                        <span className="me-2" style={{ color: 'green', marginBottom: '0px' }}>✅</span>
                      ) : messageType === 'warning' ? (
                        <span className="me-2" style={{ color: 'orange', marginBottom: '0px' }}>⚠️</span>
                      ) : (
                        <span className="me-2" style={{ color: 'red', marginBottom: '0px' }}>❌</span>
                      )}
                      <p
                        style={{
                          display: 'inline',
                          marginBottom: '0px',
                          fontSize: '14px',
                          color:
                            messageType === 'success'
                              ? 'green'
                              : messageType === 'warning'
                                ? 'orange'
                                : 'red' // Change text color based on messageType
                        }}


                        dangerouslySetInnerHTML={{ __html: modalMessage }}>
                      </p>
                    </div>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleModalClose}
                      style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }} // Adjust width, height, and position
                    ></button>
                  </div>


                </Modal>
                <Modal show={showNoRecordsModal} onHide={() => setShowNoRecordsModal(false)} style={{ marginTop: '12vh' }}>
                  <Modal.Header closeButton>
                    <Modal.Title>No Records Found</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>No records match your search criteria.</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary"
                      style={closeButtonStyle}
                      onClick={() => setShowNoRecordsModal(false)}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/* Second Modal - Select Checker */}
                <Modal
                  show={showSecondModal}
                  onHide={() => setShowSecondModal(false)}
                  centered
                  backdrop="static"  // <-- This prevents closing on outside click
                  keyboard={false}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: '#366872',
                      color: 'white',
                      padding: '0.5rem 1rem'
                    }}
                  >
                    <Modal.Title style={{ fontSize: '16px' }}>
                      Select Authorization
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                    <div dangerouslySetInnerHTML={{ __html: secondModalMessage }} />
                  </Modal.Body>

                  <Modal.Footer
                    style={{ borderTop: 'none' }}
                  >
                    <Button
                      variant="primary"
                      style={{ padding: '0.3rem 0.9rem', fontSize: '13px' }}
                      onClick={handleSecondModalNext}
                    >
                      Next
                    </Button>
                  </Modal.Footer>

                </Modal>

              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Preview;
